// @flow

import type { Windows } from '../../types/attributionWindowTypes';

export const SNAP_HUMAN_READABLE = 'Snap';
export const FACEBOOK_HUMAN_READABLE = 'Facebook';
export const TWITTER_HUMAN_READABLE = 'Twitter';

export const SNAP_MACHINE_NAME = 'a_snap';
export const FACEBOOK_MACHINE_NAME = 'a_facebook';
export const APPLE_MACHINE_NAME = 'a_apple';
export const GOOGLE_ADWORDS_MACHINE_NAME = 'a_google_adwords';
export const GOOGLE_DDM_MACHINE_NAME = 'a_google_marketing_platform';
export const TWITTER_MACHINE_NAME = 'a_twitter';
export const ROKU_MACHINE_NAME = 'a_roku';
/**
 * a_oath was already taken to supply postback
 * integration for apps during TUNE migration.
 *
 * In order to smooth migration process, we decided to create
 * a separate blueprint for SANs integration.
 *
 * This is why OATH's machine is not conventional compare to others
 */
export const OATH_MACHINE_NAME = 'a_oath_san';

export const SANS_MACHINE_NAMES = [
  SNAP_MACHINE_NAME,
  FACEBOOK_MACHINE_NAME,
  APPLE_MACHINE_NAME,
  GOOGLE_ADWORDS_MACHINE_NAME,
  GOOGLE_DDM_MACHINE_NAME,
  TWITTER_MACHINE_NAME,
  ROKU_MACHINE_NAME,
  OATH_MACHINE_NAME
];

export { UNNAMED_PARTNER } from '../../../common/support/adPartnerConstants';

export const PARTNER_MAX_ATTRIBUTION_WINDOWS: Windows = {
  impression_session_start_window_days: 30,
  impression_install_window_days: 30,
  impression_conversion_event_window_days: 30
};

export const TWITTER_MAX_ATTRIBUTION_WINDOWS: Windows = {
  click_session_start_window_days: 30,
  click_install_window_days: 30,
  click_conversion_event_window_days: 30,
  impression_session_start_window_days: 30,
  impression_install_window_days: 30,
  impression_conversion_event_window_days: 30
};

export const ATTRIBUTION_SETTINGS_TEXT = {
  TOGGLE_TITLE: 'Use ad partner attribution settings',
  getToggleTooltip: (company_name: string): string =>
    `Use a custom attribution window to match ${company_name}'s attribution windows. This overrides your app level attribution windows.`,
  INSTALL_ATTR_CHECKBOX_LABEL: 'Only attribute based on install touch',
  INSTALL_ATTR_CHECKBOX_SUBTEXT:
    'When this is checked, we will only attribute events for this partner based on the touch (click or impression) that drove the install. This is useful for ad partners that are only used for acquisition campaigns, and essentially disables "re-engagement" attribution. Other attribution windows (for example, click to conversion) still apply to the install touch.'
};

export const INSTALL_ATTR_DB_PROPERTY = 'install_touch_attribution';

export const LIMITED_DATA_USE = 'LDU';
